import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';

import { CONSTANTS } from '../../constants';

// import { GoogleSheetsDbService } from 'ng-google-sheets-db';
import { Character } from './character.model';
import { DataService } from '../../services/data.service';

// const { GoogleSpreadsheet } = require('google-spreadsheet');
const creds = require('./google-generated-creds.json');


@Component({
  selector: 'app-monthlyreport',
  templateUrl: './monthlyreport.component.html',
  styleUrls: ['./monthlyreport.component.scss']
})
export class MonthlyReportComponent implements OnInit {

  // doc = new GoogleSpreadsheet('1xyOJ-peQVlFvLg9rMmCUZYJcFNI3LTfoJ8WnnJ83ovg');


  sheet: any;

  rowValue: any;

  headers = [];

  userbrokers = [];

  admin: any;

  characters$: Observable<Character[]>;

  constructor(private dataService: DataService) { }

  ngOnInit(): void {
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.MONTHLY_REPORT});
    this.readData()
  }

  async readData(){
    // await this.doc.useServiceAccountAuth(creds);
    // await this.doc.loadInfo();
    // console.log(this.doc.title);
    // this.sheet = this.doc.sheetsByIndex[0];
    // console.log(this.sheet.title);
    
    //read row value
    // this.rowValue = await this.sheet.getRows()
    // this.headers = this.sheet.headerValues;
    // console.log(this.rowValue);
  }

  
}